<div class="tr-position d-flex flex-column gap-3">
	<span class="tr-small-line"></span>
	<span class="tr-large-line"></span>
</div>